import { Component, OnInit, AfterViewInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { TokenService } from '../../../../shared/services/token/token.service';
import { Router, ActivatedRoute } from '@angular/router';
import { SituacaoContaEnum } from '../../../../shared/enums/SituacaoConta.enum';
import { ContaService } from '../../../../shared/services/conta/conta.service';
import { ClipboardService } from 'ngx-clipboard';
import { LinkShortenerService } from '../../../../shared/services/link-shortener/link-shortener.service';
import { PixService } from '../../../../shared/services/pix/pix.service';
import {ClientNotificationService} from '../../../../shared/services/client-notification/client-notification.service';

declare const jQuery: any;
declare function unescape(s: string): string;

@Component({
  selector: 'app-pix',
  templateUrl: './pix.component.html',
  styleUrls: ['./pix.component.scss']
})
export class PixComponent implements OnInit, AfterViewInit {

  public sales: any;
  public tokenId: string;
  public token: any;
  public validationResultError: any;
  public client: string;
  public accountId: string;
  public account: any;
  public profilePicture: string;
  public bloqueio: boolean;
  public showModal: boolean;
  public msgBlock: string;
  public accountNotAllowed: boolean;
  public qrCodeData: string;
  public copyPixText = 'Copiar PIX';
  public copyText = 'Copiar Link';
  public shortLink = 'Carregando...';
  public isCobrancaAberta = false;
  public isCobrancaProcessada = false;
  public origemActuar: string;
  public loading = true;
  public pixData: any;
  public isCobrancaComProblema = false;

  constructor( private tokenService: TokenService,
               private router: Router,
               private route: ActivatedRoute,
               private contaService: ContaService,
               private _clipboardService: ClipboardService,
               private linkShortener: LinkShortenerService,
               private pixService: PixService,
               private clientNotificationService: ClientNotificationService,
               ) { }

  ngOnInit() {
    this.route.queryParams.subscribe((param) => {
        this.tokenId = param['tokenId'];
        if (this.getURLParameters('backUrl')) {
          this.origemActuar = this.getURLParameters('backUrl');
        }
      this.getToken();
    });
  }

  ngAfterViewInit() {

  }

  getToken() {
    this.loading = true;
    this.tokenService.obterToken(this.tokenId).subscribe((data: any) => {
      const link = `https://app.pague.la/#/checkout/pix?tokenId=${data.TokenId}`;
        this.linkShortener.criarLinkEncurtado(link).subscribe((str) => {
          this.shortLink = `https://link.pague.la/${str}`;
        });
        // Token does not pass twice
        if (
          data
          && data.Situacao
          && data.Situacao === 'Processado'
          && environment.production
        ) {
          // validação de pagamento expirado

        } else {

        }

        this.validationResultError = data &&
        data.Validacao &&
        data.Validacao.Erros &&
        data.Validacao.Erros.length > 0 ?
          data.Validacao.Erros[0] :
          null;

        this.getAccount(data.ContaId);

        this.token = data;
        this.sales = this.sortSales(data.Vendas);

        for ( const cobrancaPix of data.Vendas[0].CobrancasPix ) {
          this.isCobrancaAberta = cobrancaPix.Situacao === 'ABERTA';
          this.isCobrancaProcessada = cobrancaPix.Situacao === 'CONCLUIDA';
          const cobrancasProblemas = ['NAO_REALIZADO', 'DEVOLVIDO', 'REMOVIDA_PELO_USUARIO_RECEBEDOR', 'REMOVIDA_PELO_PSP'];
          if (cobrancasProblemas.find((problema) => problema === cobrancaPix.Situacao)) {
            this.isCobrancaComProblema = true;
          }

          this.pixData = cobrancaPix;
          this.qrCodeData = cobrancaPix.TextoImagemQRCode;
        }

        this.accountId = data.ContaId;
        this.client = data.Vendas[0].Cliente;

        if (this.validationResultError) {
          return;
        }
        this.loading = false;

        if (this.isCobrancaAberta && !this.isCobrancaComProblema) {
          this.verificarSePixJaFoiProcessadoEVoltar(data.ContaId);
        }
      }
      , (err) => {
        console.error(err);
        this.router.navigate(['/checkout/404']);
      });
  }

  getAccount(contaId) {
    this.contaService.obterConta(contaId).subscribe((data: any) => {
      this.account = data;

      if (this.account && this.account.Objetos && this.account.Objetos.length > 0) {
        this.account.Objetos.forEach((objeto) => {
          if (objeto.TipoObjeto === 3) {
            this.profilePicture = 'https://' + objeto.CaminhoObjeto;
          }
        });
      }

      if (this.account && this.account.Situacao == SituacaoContaEnum.Bloqueada) {
        this.bloqueio = true;
      }

      if (environment.production && data.TipoCadastro === 'PagueLa') {
        this.checkAccount();
      }
    }, (err) => {
      console.error(err);
    });
  }

  sortSales(sales) {
    let parceladas = sales.filter((sale) => sale.Parcelas !== null);
    let recorrentes = sales.filter((sale) => sale.Recorrencia);

    recorrentes = recorrentes.sort(function (a, b) {
      if (
        b.Recorrencia &&
        !b.Recorrencia.QuantidadeRecorrencia
      ) {
        return 1;
      }

      if (
        a.Recorrencia &&
        a.Recorrencia.QuantidadeRecorrencia &&
        b.Recorrencia &&
        b.Recorrencia.QuantidadeRecorrencia &&
        a.Recorrencia.QuantidadeRecorrencia > b.Recorrencia.QuantidadeRecorrencia
      ) {
        return 1;
      }

      if (
        a.Recorrencia &&
        a.Recorrencia.QuantidadeRecorrencia &&
        b.Recorrencia &&
        b.Recorrencia.QuantidadeRecorrencia &&
        a.Recorrencia.QuantidadeRecorrencia < b.Recorrencia.QuantidadeRecorrencia
      ) { return -1; }

      return 0;
    });

    parceladas = parceladas.sort(function (a, b) {
      if (a.Parcelas > b.Parcelas) { return 1; }
      if (a.Parcelas < b.Parcelas) { return -1; }
      return 0;
    });

    return sales;
  }

  checkAccount() {
    let isIncomplete = false;

    // Dados PF
    if (
      (this.account.TipoConta && this.account.TipoConta === 'Fisica') &&
      (!this.account.CpfCnpj || this.account.CpfCnpj.length === 0 ||
        !this.account.Nome || this.account.Nome.length === 0 ||
        !this.account.Sobrenome || this.account.Sobrenome.length === 0)
    ) {
      isIncomplete = true;
    }

    // Dados PJ
    if (
      (this.account.TipoConta && this.account.TipoConta === 'Juridica') &&
      (!this.account.CpfCnpj || this.account.CpfCnpj.length === 0 ||
        !this.account.RazaoSocial || this.account.RazaoSocial.length === 0 ||
        !this.account.Fantasia || this.account.Fantasia.length === 0 ||
        !this.account.Nome || this.account.Nome.length === 0)
    ) {
      isIncomplete = true;
    }

    // Endereço
    if (
      !this.account.Enderecos || this.account.Enderecos.length === 0 ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Cep || this.account.Enderecos[0].Cep.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Logradouro || this.account.Enderecos[0].Logradouro.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Numero || this.account.Enderecos[0].Numero.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Bairro || this.account.Enderecos[0].Bairro.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Cidade || this.account.Enderecos[0].Cidade.length === 0) ||
      this.account.Enderecos.length > 0 && (!this.account.Enderecos[0].Estado || this.account.Enderecos[0].Estado.length === 0)
    ) {
      isIncomplete = true;
    }

    // Informações Bancárias
    if (
      !this.account.InformacoesBancarias || this.account.InformacoesBancarias.length === 0 ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].Banco || this.account.InformacoesBancarias[0].Banco.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].Agencia || this.account.InformacoesBancarias[0].Agencia.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].NumeroConta || this.account.InformacoesBancarias[0].NumeroConta.length === 0) ||
      this.account.InformacoesBancarias.length > 0 &&
      (!this.account.InformacoesBancarias[0].ContaDigito || this.account.InformacoesBancarias[0].ContaDigito.length === 0)
    ) {
      isIncomplete = true;
    }

    if (this.account && this.account.Situacao != SituacaoContaEnum.Ativa) {
      this.openModal('O seu cadastro está pendente de aprovação.');
      return;
    }

    if (isIncomplete === true) {
      this.openModal('Os dados da sua conta estão incompletos. Faça o login e preencha os dados que estão faltando.');
      return;
    }
  }

  openModal(msg) {
    this.showModal = true;
    this.msgBlock = msg;
  }

  closeModal() {
    this.showModal = false;
    this.msgBlock = '';
  }

  getUrl(): string {
    if (this.tokenId) {
      return window.location.origin + '/#/checkout?tokenId=' + this.tokenId;
    }
  }

  copiarPix() {
    this._clipboardService.copyFromContent(this.qrCodeData);
    this.copyPixText = 'Copiado!';
  }

  copiarShortUrl() {
    this._clipboardService.copyFromContent(this.shortLink);
    this.copyText = 'Copiado!';
  }

  isValor() {
    return this.sales && this.sales.length > 0 && this.sales[0].Situacao === 'Aberta';
  }

  verificarSePixJaFoiProcessadoEVoltar(contaId) {

    this.clientNotificationService.openConnection(['onPixNotification'], contaId).subscribe((data) => {
      if ( data &&
        data.eventData &&
        data.eventData.Pix &&
        data.eventData.Pix.cobrancaPixId &&
        data.eventData.Pix.cobrancaPixId === this.pixData.CobrancaPixId) {
        this.isCobrancaAberta = false;
        this.isCobrancaProcessada = true;
        if (this.origemActuar) {
          setTimeout(() => {
            window.location.href = `${this.origemActuar}?action=CR`;
          }, 5000);
        }
      }
    });

  }

  getURLParameters(paramName) {
    const sURL = window.document.URL.toString();
    if (sURL.indexOf('?') > 0) {
      const arrParams = sURL.split('?');
      const arrURLParams = arrParams[1].split('&');
      const arrParamNames = new Array(arrURLParams.length);
      const arrParamValues = new Array(arrURLParams.length);

      let i = 0;
      for (i = 0; i < arrURLParams.length; i++) {
        const sParam =  arrURLParams[i].split('=');
        arrParamNames[i] = sParam[0];
        if (sParam[1] !== '') {
          arrParamValues[i] = unescape(sParam[1]);
        } else {
          arrParamValues[i] = null;
        }
      }

      for (i = 0; i < arrURLParams.length; i++) {
        if (arrParamNames[i] === paramName) {
          return arrParamValues[i];
        }
      }
      return null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/checkout/components/pix/pix.component.ts